/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useRef } from "react";
import { cn } from "tailwind-variants";
import { filterDomProps } from "common/vue/filter-dom-props";
/* eslint-disable max-lines-per-function */
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { PRE_CUT_IMAGE_CONFIG } from "common/pre-cut.constants";
import "./PreCutPopup.react.scss";
import InfoCircleBoldIcon from "assets/icons/info-circle-bold.svg";
export default function PreCutPopup(rawProps: any) {
  const { className, ...restProps } = rawProps;

  const props = useRef(rawProps);
  props.current = rawProps;

  function noPreCutImageUrl() {
    return remoteImageStaticUrl("gen/pre-cut-tooltip/no-pre-cut.jpeg", {
      ...PRE_CUT_IMAGE_CONFIG,
      ixlib: "rb-0.3.5"
    });
  }

  function preCutImageUrl() {
    return remoteImageStaticUrl("gen/pre-cut-tooltip/pre-cut.png", {
      ...PRE_CUT_IMAGE_CONFIG,
      ixlib: "rb-0.3.5"
    });
  }

  return (
    // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
    <div {...filterDomProps(restProps)} className={cn("pre-cut-popup scope-591df4cb", className)}>
      <InfoCircleBoldIcon
        className={cn("icon", "icon--svg", "icon--info-circle-bold", "scope-591df4cb")}
        height="16"
        width="16"
        data-testid="icon-svg"
      />

      <div className={cn("pre-cut-popup__tooltip", "scope-591df4cb")}>
        <div className={cn("pre-cut-popup__title", "scope-591df4cb")}>🔍 What’s pre-cut?</div>
        <div className={cn("pre-cut-popup__body", "scope-591df4cb")}>
          <p className={cn("pre-cut-popup__description", "scope-591df4cb")}>
            {" "}
            Pre-cut transfers are ready to apply right out of the package—no trimming required!{" "}
            <br className={cn("scope-591df4cb")} /> This ensures a faster, cleaner application every
            time.{" "}
          </p>
          <div className={cn("pre-cut-popup__comparison", "scope-591df4cb")}>
            <div className={cn("pre-cut-popup__comparison-container", "scope-591df4cb")}>
              <div className={cn("pre-cut-popup__comparison-image-container", "scope-591df4cb")}>
                <img
                  className={cn("pre-cut-popup__comparison-image", "scope-591df4cb")}
                  src={noPreCutImageUrl()}
                  alt="No Pre-cut Image"
                />
              </div>
              <div className={cn("pre-cut-popup__comparison-title", "scope-591df4cb")}>
                No Pre-cut
              </div>
              <div className={cn("pre-cut-popup__comparison-description", "scope-591df4cb")}>
                {" "}
                Time per 10 transfers:{" "}
              </div>
              <div className={cn("pre-cut-popup__comparison-duration", "scope-591df4cb")}>
                10 minutes
              </div>
            </div>
            <div className={cn("pre-cut-popup__comparison-container", "scope-591df4cb")}>
              <div className={cn("pre-cut-popup__comparison-image-container", "scope-591df4cb")}>
                <img
                  className={cn("pre-cut-popup__comparison-image", "scope-591df4cb")}
                  src={preCutImageUrl()}
                  alt="No Pre-cut Image"
                />
              </div>
              <div className={cn("pre-cut-popup__comparison-title", "scope-591df4cb")}>Pre-cut</div>
              <div className={cn("pre-cut-popup__comparison-description", "scope-591df4cb")}>
                {" "}
                Time per 10 transfers:{" "}
              </div>
              <div
                className={cn(
                  "pre-cut-popup__comparison-duration",
                  "pre-cut-popup__comparison-duration-precut",
                  "scope-591df4cb"
                )}
              >
                {" "}
                0 minutes{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
